import { gql } from '@apollo/client'
import { POST_ITEM_USER } from './fragments'
/** 工作流广场列表 */
export const GET_WORK_FLOW_PLAZA_LIST = gql`
  ${POST_ITEM_USER}
  query getWorkFlowPlazaList(
    $first: Int
    $offset: Int
    $param: PostQueryInput
  ) {
    squareModule {
      squareWorkFlowPage(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        edges {
          node {
            id
            type
            title
            content
            status
            visibleType
            sameCount
            createLikewiseCast
            createTags {
              id
              icon
              name
              publishVisible
            }
            user {
              ...postItemUser
            }
            coverImage {
              id
              imageUrl
              width: length
              height: width
              sourceType
            }
            aiWorkFlow {
              id
              paramVisible
              nodes {
                artworkInfo {
                  aiType
                  aiSubdivisionType
                }
              }
            }
            itemSocialInfo {
              showViewCount
            }
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 工作流广场标签 */
export const GET_WORK_FLOW_TAG_OPTIONS = gql`
  query getWorkflowTagOptions {
    squareModule {
      squareOptionMenu {
        createTagOptions(optionType: WORKFLOW_TAG) {
          id
          icon
          hoverIcon
          name
          publishVisible
        }
      }
    }
  }
`
